<template>
    <label
        class="c-form_radio"
        ref="label"
        :disabled="disabled"
        :tabindex="disabled ? false : 0"
        :class=" { 'c-form_radio--error' : getError }"
        @keydown.prevent.enter.space="$refs.label.click()">
        <input
            v-model="newValue"
            type="radio"
            :value="nativeValue"
            :name="inputName"
            class="c-form_radio__input">
        <span class="c-form_radio__checkmark"></span>
        <span>
          <slot></slot>
        </span>
    </label>
</template>


<script>

export default {

    name: 'FormRadio',

    $_veeValidate: {
        name() {
            return this.inputName
        },
        value() {
            return this.value;
        },
    },

    props: {
        value: [String, Number],
        nativeValue: [String, Number],
        label: String,
        name: String,
        type: {
            type: String,
            default: "text"
        },
        disabled: Boolean,
        error: String,
    },

    data() {
        return {
            newValue: this.value,
        }
    },

    computed: {
        inputName() {
            var tmp_name = this.$vnode.data.model.expression.split('.')
            var name = ''

            if (tmp_name.length > 1)
                name = tmp_name[tmp_name.length - 1]
            else
                name = tmp_name[0]

            return this.name || name
        },
        getError() {
            var err = this.errors.items.filter((error) => {
                return (error.field === this.inputName)
            })

            if (err.length)
                return err[0].msg
            else
                return null
        },
    },

    watch: {
        value(value) {

            this.newValue = value
        },
        newValue(value) {
            if (value === this.nativeValue) {
                this.$emit('input', value)
            }
        }
    },

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-form_radio {
    display: inline-flex;
    width: 50%;
    align-items: center;
    margin-bottom: 1rem;
    padding-right: 1.4rem;
    cursor: pointer;
    outline: 0;

    @include bp(500px) {
        width: 100%;
    }
    &--error {
        color: $c-red;
    }
    &__checkmark {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 1px solid $c-border;
        border-radius: 50%;
        background-color: $c-white;
        margin-right: 10px;
        flex-shrink: 0;

        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1;
            transform: translate(-50%, -50%);
            width: 0px;
            height: 0px;
            border-radius: 50%;
            background-color: $c-primary;
            transition: width .2s cubic-bezier(.24, .05, .12, 1.62), height .2s cubic-bezier(.24, .05, .12, 1.62);
        }
    }
    &__input:checked + &__checkmark:after {
        width: 10px;
        height: 10px;
    }
    &__input {
        position: absolute;
        opacity: 0;
    }
    &__title {
        font-size: 1rem;
    }
}

</style>
